module.exports = __webpack_public_path__ + "static/media/annoucement.626a2762.jpg";